import styled from "styled-components";
import media from "constants/media";

export const QuantityValueStyled = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    ${media.smUp`
         flex-direction: row;
         margin-bottom: 20px;
    `}
`;
